import { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import {
  GET_ALL_RESPONSES,
  GetAllResponsesGql,
  GetAllResponsesItem,
  CellProps,
} from "./queries/getAllResponses";
import { AnalysisButton } from "layouts/aplicacoes/BlogComments/styles";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import ModalContent from "./components/ModalContent";
import { ApiFormCancelResponsesWithSetData } from "./hooks/apiSetData";
import { StatusBox } from "layouts/aplicacoes/Orders/hooks/StatusBox";
import { Information } from "./components/Information";
import { Accordion } from "components/CRPComponents/Accordion";
import LongTextCell from "components/CRPComponents/Tables/components/LongTextCell";

function List({ path }: ListProps) {
  const [content, setContent] = useState<GetAllResponsesItem | null>();

  const handleOpenModalContent = (data: GetAllResponsesItem) => {
    setContent(data);
  };

  return (
    <Fragment>
      <DashboardLayout>
        <DashboardNavbar />
        <GenericTable<GetAllResponsesGql>
          initialVariables={{ formSlug: "form-cancel", perPage: 5 }}
          path={`${path}/cancelamento`}
          createAddPath="editar"
          title={"Lista de E-mails"}
          query={GET_ALL_RESPONSES}
          formatRows={(data) => data.FormResponses.items}
          formatPagination={(data) => data.FormResponses?.paginationInfo}
          ApiSetData={ApiFormCancelResponsesWithSetData}
          useDefaultFilter={false}
          columnsTable={[
            {
              Header: "id",
              accessor: "id",
              Cell: ({ value }: any) => (
                <LinkCell value={value} href={`${path}/cancelamento/${value}`} />
              ),
            },
            {
              Header: "Criado em",
              accessor: "createdAt",
              Cell: ({ value }: any) => (
                <DefaultCell value={new Date(value).toLocaleDateString()} />
              ),
            },
            // {
            //   Header: "Nome",
            //   accessor: "responseJson.Nome",
            //   Cell: ({ value }: any) => <DefaultCell value={value || ""} />,
            // },
            {
              Header: "Email",
              accessor: "responseJson.Email",
              Cell: ({ value }: any) => <DefaultCell value={value || ""} />,
            },
            {
              Header: "Id Pedido",
              accessor: "responseJson.OrderId",
              Cell: ({ value }: any) => {
                if (!value) {
                  return <DefaultCell value={""} />;
                }
                return <LinkCell value={value} href={`/ecommerce/pedidos/${value}`} />;
              },
            },
            {
              Header: "Resposta",
              accessor: "response",
              Cell: ({ value, cell }: CellProps) => (
                <AnalysisButton onClick={() => handleOpenModalContent(cell.row.original)}>
                  ver
                </AnalysisButton>
              ),
            },
            {
              Header: "Comentário Interno",
              accessor: "internalInfo",
              Cell: ({ value }: any) => <LongTextCell value={value || ""} maxLength={50} />,
            },
            {
              Header: "Status Solicitação",
              accessor: "status",
              Cell: ({ value, cell }: any) => {
                return (
                  <Link
                    to={`${path}/cancelamento/${cell.row.original.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <StatusBox status={value || "Pendente"} />
                  </Link>
                );
              },
            },
          ]}
        />
        <Accordion
          title={{ component: <p>Observações</p> }}
          content={{ component: <Information /> }}
          defaultOpen
        />
        <Footer />
      </DashboardLayout>

      <ModalContent content={content} onClose={() => setContent(null)} />
    </Fragment>
  );
}

export default List;
